import { z } from 'zod';

export const DoctorSchema = z
    .object({
        clinic_group_crm: z.string(),
        user_fk: z.string(),
        location_id: z.string(),
        doctor_id: z.string(),
        display_name: z.nullable(z.string()),
        gender: z.nullable(z.string()),
        about: z.nullable(z.string()),
        appt_types: z.array(z.string()).or(z.boolean()),
        appt_types_duration: z.record(z.string(), z.string()).or(z.boolean()),
        is_nurse_or_doc: z.nullable(z.string()),
        sort_order: z.nullable(z.string()),
        allow_online_app: z.nullable(z.string()),
        allow_walk_ins: z.nullable(z.string()),
        room_no: z.nullable(z.string()),
        no_new_patients: z.nullable(z.string()),
        my_patients: z.nullable(z.string()),
        display_only: z.nullable(z.string()),
        allow_scripts: z.nullable(z.string()),
        allow_referrals: z.nullable(z.string()),
        enable_doc_notice: z.nullable(z.string()),
        doc_notice: z.nullable(z.string()),
        in_isolation: z.nullable(z.string()),
        iso_date: z.nullable(z.string()),
        location_display_name: z.nullable(z.string()),
        first_name: z.nullable(z.string()),
        last_name: z.nullable(z.string()),
        image: z.nullable(z.string()),
        enable_scripts: z.nullable(z.string()),
        enable_referrals: z.nullable(z.string()),
        clinic_lat: z.number().optional(),
        clinic_long: z.number().optional(),
        relative_time: z.number().optional(),
        clinic_address: z.nullable(z.string()),


    })
    .partial();

export type Doctor = z.TypeOf<typeof DoctorSchema>;